<template>
  <div class="loader"></div>
</template>

<script>
export default {}
</script>
